import React, { useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Avatar,
  IconButton,
  ListItemIcon,
  MenuItem,
  Typography,
  Divider,
  Tooltip,
} from "@material-ui/core";
import Person from "@material-ui/icons/PersonOutlined";
import SettingsIcon from "@material-ui/icons/Settings";
import HomeIcon from "@material-ui/icons/Home";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/styles";
import { StorageUser } from "../main/StorageUser";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";


import LojaPicker from "./LojaPicker";
import consts from "../main/consts";

const useStyles = makeStyles((theme) => ({
  contentAvatar: {
    padding: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  close: {
    padding: "20px 20px",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  avatar: {
    margin: "0 auto",
    width: 68,
    height: 68,
    boxSizing: "content-box",
    fontSize: 34,
    "& > img": {
      borderRadius: "50%",
    },
  },
  contentUserName: {
    textAlign: "center",
    minWidth: 200,
    paddingTop: 12,
  },
  name: {
    fontSize: 16,
  },
  role: {
    fontSize: 12,
  },
  iconList: {
    minWidth: 40,
  },
  drawerPaper: {
    position: "fixed",
    width: 280,
    borderRadius: 0,
    borderTop: "none",
    borderBottom: "none",
  },
  divider: {
    margin: "40px 20px 40px",
  },
  dividerProfile: {
    margin: "10px 130px 10px",
  },
  iconMenu: {
    paddingBottom: 20,
  },
}));

function UserMenu(props) {
  const { logout, appuser, openTutorial } = props;
  const { loja, lojas } = useSelector((state) => state.auth);
  const [userMenu, setUserMenu] = useState(false);
  const [lojaPicker, setLojaPicker] = useState(false);
  const anchorRef = useRef(null);
  const history = useHistory();
  const classes = useStyles();
  const storageUser = new StorageUser();

  const userMenuClick = (event) => {
    setUserMenu(true);
  };

  const userMenuClose = () => {
    setUserMenu(false);
  };

  return (
    <React.Fragment>
      <Tooltip title="Perfil" aria-label="Perfil" placement="bottom">
        <IconButton color="inherit" onClick={userMenuClick} ref={anchorRef}>
          <Person fontSize={"large"} />
        </IconButton>
      </Tooltip>

      <Drawer
        variant="persistent"
        anchor="right"
        open={userMenu}
        elevation={0}
        PaperProps={{
          variant: "elevation",
        }}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.close}>
          <a onClick={userMenuClose}>
            <CloseIcon style={{ width: 40 }} />
          </a>
        </div>
        <div className={classes.contentAvatar}>
          <Person fontSize={"large"}  />
        </div>
        <Divider className={classes.dividerProfile} />
        <div className={classes.contentAvatar}>
          <Typography style={{ color: "black", fontSize: 16 }}>
            Loja {loja}
          </Typography>
        </div>

        <Divider className={classes.divider} />

        <React.Fragment>
          <div style={{ flex: 1 }}>
            <Typography
              style={{ marginLeft: 20, marginBottom: 5, fontSize: 12 }}
            >
              Menu
            </Typography>
            <MenuItem
              onClick={() => {
                history.push(`${consts.CONTEXT}/all-orders`);
                userMenuClose();
              }}
              className={classes.iconMenu}
            >
              <ListItemIcon className={classes.iconList}>
                <HomeIcon fontSize={"small"} htmlColor={"black"} />
              </ListItemIcon>
              <Typography style={{ color: "black" }}>Página Inicial</Typography>
            </MenuItem>

            {storageUser.allowedByPermission("AUDITORIA_LOGS") && (
              <MenuItem
                onClick={() => {
                  history.push(`${consts.CONTEXT}/auditoria`);
                  userMenuClose();
                }}
                className={classes.iconMenu}
              >
                <ListItemIcon className={classes.iconList}>
                  <AssignmentIcon fontSize={"small"} htmlColor={"black"} />
                </ListItemIcon>
                <Typography style={{ color: "black" }}>Auditoria</Typography>
              </MenuItem>
            )}
            {lojas && lojas.length > 0 && (
              <MenuItem
                onClick={() => {
                  setLojaPicker(true);
                  userMenuClose();
                }}
                className={classes.iconMenu}
              >
                <ListItemIcon className={classes.iconList}>
                  <SettingsIcon fontSize={"small"} htmlColor={"black"} />
                </ListItemIcon>
                <Typography style={{ color: "black" }}>Loja</Typography>
              </MenuItem>
            )}
          </div>
          <div style={{ padding: 15 }}>
            <Button
              fullWidth
              size="large"
              variant="outlined"
              color="default"
              style={{
                width: 250,
                backgroundColor: "#cccccc",
                borderRadius: 3,
                color: "#333333",
                border: "none",
              }}
              onClick={() => {
                logout();
                userMenuClose();
              }}
            >
              SAIR
            </Button>
          </div>
        </React.Fragment>
      </Drawer>

      <LojaPicker
        open={lojaPicker}
        anchor={anchorRef.current}
        onClose={() => {
          userMenuClose();
          setLojaPicker(false);
        }}
        lojas={lojas}
      />
    </React.Fragment>
  );
}

export default UserMenu;
